<template>
  <div class="site-footer">
    <div class="site-footer__navigation-bar">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-10 col-lg-offset-1">
            <site-navigation :page-data="pageData" />
            <facebook-link
              :page-data="pageData"
              class="site-footer__facebook-link--desktop hidden-xs hidden-sm"
            />
          </div>
        </div>
        <div class="row">
          <div
            class="
              col-xs-12 col-md-4
              site-footer__legal-navigation-column
            "
          >
            <legal-navigation :page-data="pageData" />
          </div>
          <div class="col-xs-12 col-md-4">
            <site-footer-guarantee :page-data="pageData" />
          </div>
          <div
            class="
              col-xs-12 col-md-4
              text-center
              site-footer__permission-column
            "
          >
            <legal-notice :page-data="pageData" />
          </div>
        </div>
        <div class="text-center hidden-md hidden-lg">
          <facebook-link :page-data="pageData" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteFooterGuarantee from './SiteFooterGuarantee.vue'
import SiteNavigation from './Navigation.vue'
import LegalNavigation from './LegalNavigation.vue'
import LegalNotice from './LegalNotice.vue'
import FacebookLink from './FacebookLink.vue'

export default {
  name: 'SiteFooter',
  components: {
    FacebookLink,
    LegalNavigation,
    SiteNavigation,
    SiteFooterGuarantee,
    LegalNotice
  },
  data () {
    return {
      pageData: window.pageData.siteFooter
    }
  }
}
</script>

<style lang="scss" scoped>
@include circularstd-fontface("../../../shared/fonts");

.site-footer {
  bottom: 0;
  width: 100%;
  background-color: #fff;
  color: #535353;
  font-size: 1rem;
  font-family: $font-circular-std;

  @media screen and (min-width: $screen-sm-min) {
    background-color: #f0f4f7;
  }

  &__navigation-bar {
    padding: 36px 0 20px 0;

    @media screen and (min-width: $screen-sm-min) {
      padding: 36px 0 6px;
    }
  }

  &__facebook-link--desktop {
    position: absolute;
    top: 0;
    right: 10px;
  }

  &__permission-column {
    margin-bottom: 10px;

    @media screen and (min-width: $screen-md-min) {
      margin-bottom: 0;
      padding-top: 4rem;
    }
  }

  @media screen and (min-width: $screen-md-min) {
    &__legal-navigation-column {
      padding-top: 4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/site-footer/components/SiteFooter.vue